import React from 'react';
import style from './style.module.scss';
import Icon from '../../assets/icons';
import TopicOverviewIllustration from '../../assets/topic_overview.svg';
import { paths } from 'config/path_helpers';
import Tabs from '../../lib/tabs';
import { TopicOverviewProvider } from './context';
import { UserProvider } from '@magoosh/context/user_context';
import MathContent from './tabs/math_content';
import VerbalContent from './tabs/verbal_content';
import WritingContent from './tabs/writing_content';
import TopicPerformanceExplanationModal from '../../organisms/topic_performance_explanation_modal';
import { HeaderWithIllustration } from '../../lib/header_with_illustration';
import { PageCard } from '../../lib/page_card';
import { Wrapper } from '../../lib/wrapper';

export const TopicOverview: React.FC = () => {
  return (
    <Wrapper>
      <div className="u-margin-V-m">
        <a href={paths.dashboard()}>
          <strong>Home</strong>
        </a>{' '}
        {'>'} <span>Topic Overview</span>
      </div>

      <PageCard>
        <HeaderWithIllustration
          illustration={TopicOverviewIllustration}
          illustrationAltText={'Topic Overview Illustration'}
          icon={<Icon iconType="Topic" fill={style.iconSecondary} />}>
          <h2 className="u-margin-A-n">
            <strong>Topic Overview</strong>
          </h2>
          <p>
            View your progress through all topics available in Magoosh and add specific topics to your study
            plan as desired.
          </p>
        </HeaderWithIllustration>

        <TopicOverviewProvider>
          <UserProvider>
            <Tabs defaultTab="math">
              <hr className="u-margin-B-xs" />
              <div className="text-center">
                <Tabs.Tab tab="math">Math</Tabs.Tab>
                <Tabs.Tab tab="verbal">Verbal</Tabs.Tab>
                <Tabs.Tab tab="writing">Writing</Tabs.Tab>
              </div>
              <hr className="u-margin-T-xs" />

              <Tabs.Panel tab="math">
                <MathContent />
              </Tabs.Panel>

              <Tabs.Panel tab="verbal">
                <VerbalContent />
              </Tabs.Panel>

              <Tabs.Panel tab="writing">
                <WritingContent />
              </Tabs.Panel>
            </Tabs>
            <TopicPerformanceExplanationModal />
          </UserProvider>
        </TopicOverviewProvider>
      </PageCard>
    </Wrapper>
  );
};

export default TopicOverview;
